import { get } from 'lodash';

export const isLoading = state => get(state, 'subscriptions.stripe.loading');
export const getCustomer = state => get(state, 'subscriptions.stripe.customer');
export const getPk = state => get(state, 'subscriptions.stripe.pk');
